import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

interface MobileWrapperPropsType {
    isMobileGridOpen: boolean;
}

export const MobileWrapper = withConfig(theme => styled('div', { label: 'MobileWrapper' })<MobileWrapperPropsType>`
    @supports not (height: 100vh) {
        top: 100%;
    }
    background: ${theme.star.casino.casinoMini.colors.bgPrimary};
    border-radius: ${theme.star.casino.casinoMini.radius} ${theme.star.casino.casinoMini.radius} 0 0;
    display: flex;
    flex-flow: column nowrap;
    margin-top: ${({ isMobileGridOpen }): string => isMobileGridOpen ? '0' : '-88px'};
    max-height: 66vh;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 100dvh;
    transform: ${({ isMobileGridOpen }): string => isMobileGridOpen ? 'translateY(-100%)' : 'translateY(0)'};
    transition: transform .5s ease-out;
    width: 100%;
    z-index: ${theme.star.zIndexGlobal.miniGamesGridMobile};
    @media ${theme.star.mediaQuery.xxMobile} {
        max-width: 390px;
    }
`);

export const DesktopWrapper = withConfig(theme => styled('div', { label: 'DesktopWrapper' })`
    background: ${theme.star.casino.casinoMini.colors.bgTertiary};
    border-radius: ${theme.star.casino.casinoMini.radius};
    margin: 0 8px 10px;
    overflow: hidden;
    padding: 8px;
`);
